import http, { BASE_URL_API_ECOMMERCE } from "./Http";

// Fetch marketplace data based on various filters
const fetchMarketplaceData = async ({
    dealerId = "",
    region = "USA", // 1 = USA, 2 = CAN
    catalogs = [],
    loc = "en",
    from = null,
    to = null,
    platform = null,
    vehicles = [],
    categories = [],
}) => {
    const queryString = new URLSearchParams({
        dealerId,
        region,
        catalogs: catalogs.join(","),
        loc,
        from,
        to,
        platform,
        categories: categories.join(","),
    }).toString();

    const baseUrl = BASE_URL_API_ECOMMERCE.replace(/\/api$/, "");

    const res = await http.post(`${baseUrl}/marketplace-export?${queryString}`, {
        vehicles,
    });

    return res.data.data;
};

const generateMLExcel = async ({ dealerId, products = [] }) => {
    return http.post(`/meli-excel-exporter`, { dealerId, products });
};

const deleteMLExcel = async ({ dealerId, fileName }) => {
    return http.post(`/meli-excel-exporter/delete`, { dealerId, fileName });
};

const generateGoogleExcel = async ({ dealerId, products = [] }) => {
    return http.post(`/google-exporter`, { dealerId, products });
};

const fetchInventoryData = async ({
    skus = [],
    minStockLevel = null,
    dimWeightFrom = null,
    dimWeightTo = null,
}) => {
    const res = await http.post(`/inventory-availability`, {
        skus,
        minStockLevel,
        dimWeightFrom,
        dimWeightTo,
    });
    return res.data.data;
};

const fetchInventoryObservations = async ({
    skus = [],
    minStockLevel = null,
    dimWeightFrom = null,
    dimWeightTo = null,
}) => {
    const res = await http.post(`/inventory-observations`, {
        skus,
        minStockLevel,
        dimWeightFrom,
        dimWeightTo,
    });
    return res.data.data;
};

const checkSftpCredentials = async ({ dealerId, ftpServerName, ftpUsername, ftpPassword }) => {
    const res = await http.post(`/ftp-check-credentials`, {
        dealerId,
        ftpServerName,
        ftpUsername,
        ftpPassword,
    });
    return res.data;
};

const uploadExcelToFTP = async ({ dealerId, fileName, remoteFolder }) => {
    const res = await http.post(`/ftp-upload`, {
        dealerId,
        fileName,
        remoteFolder,
    });
    return res.data;
};

const ExportService = {
    fetchMarketplaceData,
    generateMLExcel,
    deleteMLExcel,
    generateGoogleExcel,
    fetchInventoryData,
    fetchInventoryObservations,
    checkSftpCredentials,
    uploadExcelToFTP,
};

export default ExportService;
